import * as angular from "angular";
import {IController} from "angular";

export class DashboardViewComponent implements IController {

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('dashboardView', {
    bindings: {
    },
    template: require('./dashboard-view.html').default,
    controller: DashboardViewComponent
  });
